import { ChangeAssigneeField } from '@/components/cards/DealCardValues/ChangeAssigneeField';
import { DealAmount } from '@/components/cards/DealCardValues/DealAmount';
import { DealCardDateSelect } from '@/components/cards/DealCardValues/DealCardDateSelect';
import { DealCardStageChange } from '@/components/cards/DealCardValues/DealCardStageChange';
import { OutstandingDaysCounter } from '@/components/cards/DebtorOutstandingDaysCard';
import { ClaimNumberField } from '@/components/ClaimNumberField';
import DebtorAutomationPanel from '@/components/views/DebtorsView/DebtorAutomationPanel';
import { useFeatureFlagContext } from '@/context/featureFlagContext';
import { useObjectContext } from '@/hooks/useObjectContext';
import { Box, FormControl, FormLabel, Grid, Stack, Typography } from '@mui/material';
import React, { useMemo } from 'react';
const DealDrawerContent = () => {
	const { dealRow, dealId } = useObjectContext();

	const isDeal = dealRow?.objectType === 'deal';
	const isClaim = dealRow?.pipeline == process.env.REACT_APP_PIPELINE_CLAIMS;
	const isDebtor = dealRow?.pipeline == process.env.REACT_APP_PIPELINE_DEBTORS;
	const isRenewal = dealRow?.pipeline == process.env.REACT_APP_PIPELINE_RENEWALS;
	const isNewBusiness = dealRow?.pipeline == process.env.REACT_APP_PIPELINE_NEW_BUSINESS;
	const isEndorsement = dealRow?.pipeline == process.env.REACT_APP_PIPELINE_ENDORSEMENTS;

	const policies = dealRow?.policies || [];

	const { getFeatureFlags } = useFeatureFlagContext();
	const automatedDebtors = Boolean(getFeatureFlags('automatedDebtors')?.active);

	const getStageTitle = () => {
		if (isDebtor) return 'Debtor stage';
		if (isClaim) return 'Claim status';
		return 'Deal stage';
	};

	const cardValues = useMemo(() => {
		if (isDebtor) {
			return [
				<Stack key='debtor-outstanding-days' spacing={2}>
					<OutstandingDaysCounter />
					{automatedDebtors && <DebtorAutomationPanel />}
				</Stack>,
			];
		}

		if (isRenewal) {
			return [
				<DealCardDateSelect
					key='deal-card-value-renewal-date'
					title='Renewal date'
					dealKey='renewalDate'
				/>,
			];
		}

		if (isNewBusiness) {
			return [
				<DealAmount key='deal-card-value-amount' />,
				<DealCardDateSelect
					key='deal-card-value-estimated-close'
					title='Estimated close date'
					dealKey='estimatedCloseDate'
				/>,
			];
		}

		if (isClaim) {
			return [
				<FormControl key='claim-number' fullWidth>
					<FormLabel>Claim Number</FormLabel>
					<ClaimNumberField />
				</FormControl>,
				<Stack key='insurer'>
					<FormLabel>Insurer</FormLabel>
					<Box sx={{ minHeight: '32px', display: 'flex', alignItems: 'center' }}>
						<Typography>
							{dealRow?.insurer ?? policies?.[0]?.InsurerName ?? 'Unknown'}
						</Typography>
					</Box>
				</Stack>,
			];
		}

		return [];
	}, [
		isDebtor,
		isRenewal,
		isDeal,
		isEndorsement,
		isClaim,
		automatedDebtors,
		dealId,
		dealRow?.insurer,
		policies,
	]);

	return (
		<>
			<Grid size={{ xs: 12, sm: 6 }} sx={{ marginTop: 1.9 }}>
				<DealCardStageChange
					minimal={true}
					showLabel
					title={getStageTitle()}
					{...(isClaim && { showReopen: true })}
				/>
			</Grid>

			<Grid size={{ xs: 12, sm: 6 }}>
				<ChangeAssigneeField minimal={true} />
			</Grid>

			{cardValues.map((element, index) => (
				<Grid size={{ xs: 12, sm: isDebtor ? 12 : 6 }} key={`about-values-${index}`}>
					{element}
				</Grid>
			))}
		</>
	);
};
DealDrawerContent.displayName = 'DealDrawerContent';
export default DealDrawerContent;
